export const MAIN_PRICES = [
  { name: "Furniture Removal", price: 75, desc: "Couches, chairs, tables, beds, dressers, and more." },
  { name: "Appliance Removal", price: 75, desc: "Fridges, washers, dryers, stoves, water heaters, and more." },
  { name: "Mattress Removal", price: 60, desc: "Twin, full, queen, king, box springs, and more." },
  { name: "Hot Tub Removal", price: 250, desc: "Above-ground and in-ground hot tubs." },
  { name: "Treadmill Removal", price: 75, desc: "All brands and sizes." },
  { name: "Yard Waste Removal", price: 60, desc: "Branches, brush, leaves, trimmings, and more." },
  { name: "Garage Cleanouts", price: 100, desc: "Get your garage back and reclaim your space." },
  { name: "Construction Debris Removal", price: 100, desc: "Wood, drywall, concrete, shingles, and more." },
  { name: "Whole-House Cleanouts", price: 300, desc: "From a single room to the entire home." },
];

export const EXTRA_PRICES = [
  { name: "Shed Cleanouts", price: 100, desc: "Remove old items, debris, and unwanted clutter from your shed." },
  { name: "Attic Cleanouts", price: 150, desc: "Clear out years of buildup and get your attic back in usable space." },
  { name: "Crawl Space Cleanouts", price: 150, desc: "Remove debris, insulation, and unwanted items from your crawl space." },
  { name: "Storage Cleanouts", price: 100, desc: "Clean out storage units, closets, and extra spaces." },
  { name: "Small Motorized Vehicles", price: 75, desc: "ATVs, dirt bikes, lawn mowers, jet skis, and more." },
];

export const DISCLAIMER = "All prices are starting estimates. Final quotes depend on volume, labor, accessibility, and disposal fees. Contact Cazares Junk Removal for a free personalized estimate.";
